import type { ReactNode } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * A single label-over-value row for a detail page's read view. This was
 * defined verbatim (a 6-line local `Field`) in every detail page — companies,
 * integrations, toolkits, and questions in both apps — so it lives here as the
 * one definition all of them share.
 */
export function DetailField({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <div>
      <Text strong>{label}</Text>
      {/* A long unbroken value (a URL, a token) breaks rather than running
          off a phone screen. */}
      <div style={{ overflowWrap: 'anywhere' }}>{value}</div>
    </div>
  );
}
